import { BaseAPI, Common } from '../common';
import {
  WorkflowTest,
  WorkflowTestPopulated,
  type CreateValues,
  type UpdateValues,
} from '../models/workflowTest';

import Entity from './entity';

export class API extends BaseAPI {
  Entity: Entity;

  constructor(common: Common) {
    super(common);
    this.Entity = new Entity(common);
  }

  async findOneById(id: string): Promise<WorkflowTestPopulated> {
    const url = this.common.constructPath(`/workflow-test/${id}`);
    return this.common.getJSON(url);
  }

  async findAll(): Promise<WorkflowTestPopulated[]> {
    const url = this.common.constructPath('/workflow-test/');
    return this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<WorkflowTest> {
    const url = this.common.constructPath('/workflow-test/');
    return this.common.postJSON(url, values);
  }

  async update(values: UpdateValues): Promise<WorkflowTest> {
    const url = this.common.constructPath(`/workflow-test/${values.id}`);
    return this.common.patchJSON(url, values);
  }
}
